import React from 'react'
import { StrapiFile } from '@shared/utils/strapi/strapi.types'
import * as S from './styles'

interface DraggableImageProps {
  readonly image: StrapiFile & { localFile?: any }
  readonly onClick: () => void
}

const DraggableImage: React.FC<DraggableImageProps> = ( { image, onClick } ) => {
  const drag = React.useRef( false )

  const setDrag = ( value: boolean ): void => {
    drag.current = value
  }

  const handlers = {
    'onMouseDown': () => setDrag( false ),
    'onMouseMove': () => setDrag( true ),
    'onMouseUp': () => {
      if ( !drag.current ) {
        onClick()
      }
    },
    'onTouchStart': () => setDrag( false ),
    'onTouchMove': () => setDrag( true ),
    'onTouchEnd': () => {
      if ( !drag.current ) {
        onClick()
      }
    },
  }

  return (
    <S.ImageWrapper { ...handlers }>
      <S.StyledImageCustom
        image={ image }
        alt="Imagem carrossel"
      />
    </S.ImageWrapper>
  )
}

export default DraggableImage
